import { createSlice } from "@reduxjs/toolkit";

/** Legacy slice — kept for store compatibility; office inbox uses `schooldetails[].messages`. */
const Insider = createSlice({
  name: "messages",
  initialState: [],
  reducers: {
    messages: (state, action) => {
      const next = action.payload?.announcement;
      return Array.isArray(next) ? next : [];
    },
  },
});

export const { messages } = Insider.actions;
export default Insider.reducer;
